import React, { memo } from "react";
import { FormSection } from "redux-form";

import { PrimaryContact } from "./../../formSections/primaryContact/primaryContact";
import { OwnerPrincipalSection } from "../../formSections";

import { ReactComponent as WarningIcon } from "static/images/warning-alert.svg";
import styles from "./principalInfo.module.scss";

let PrincipalInfoFields = ({
	formValues,
	ownersValidationInfo,
	formName,
	isPaperApplication,
}) => {
	const owners = formValues?.ownerPrincipalSection?.owners;

	const signer = formValues?.ownerPrincipalSection?.signer;

	ownersValidationInfo = ownersValidationInfo.filter(
		(x, i) => i < (owners || [{}]).length,
	);

	return (
		<>
			<div className="d-flex text-warning">
				<div className="pr-3">
					<WarningIcon width="16" />
				</div>
				<div>
					<p>
						Provide the following information for each individual
						who owns, directly or indirectly, 25 % or more of the
						equity interest of your business. If no single owner
						owns more than 25%, an individual with significant
						responsibility can be added as principal 1*.
					</p>
					<p>
						*Individual with significant responsibility includes an
						executive officer or owner with authority to control,
						manage, and direct the legal entity (e.g. a Chief
						Executive Officer, Chief Financial Officer, Managing
						Member, General Partner, President, Vice President, or
						Treasurer) or any individual with authority to perform
						such functions.
					</p>
				</div>
			</div>
			<FormSection name="ownerPrincipalSection">
				<OwnerPrincipalSection
					formName={formName}
					owners={owners}
					signer={signer}
					isTinOptional={true}
					isPaperApplication={isPaperApplication}
				/>
			</FormSection>
			<hr className={styles.divider} />
			<PrimaryContact
				isPrimaryContactTheSame
				isPrimaryContactTheSameValue={
					formValues?.isPrimaryContactTheSame
				}
				isRequired
				formName={formName}
			/>
		</>
	);
};

const component = memo(PrincipalInfoFields);
export { component as PrincipalInfoFields };
